// Built-in imports
import { motion } from "framer-motion";
// Internal imports
import { Wrapper } from "./title-component.styles";
import sectionWrapper from "../../hoc/sction-wrapper.component";
import { fadeIn } from "../../utils/motion/motion.utils";

const Title = ({ align, title }) => {
  return (
    <motion.div variants={fadeIn("", "", 0.1, 1)}>
      <Wrapper>
        <motion.div
          initial={{ rotateZ: 0 }}
          animate={{
            rotateX: 360,
            rotateY: 360,
          }}
          transition={{ duration: 2, repeat: Infinity }}
          className={`squar animate-ping ${
            align === "left" ? "align-left" : "align-right"
          }`}
        />
        <h2 className={`${align === "left" ? "text-left" : "text-right"}`}>
          {title}
        </h2>
      </Wrapper>
    </motion.div>
  );
};
export default sectionWrapper(Title);
